module.exports = __webpack_public_path__ + "static/media/unicharm.ef9d0fe6.png";